import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import CardLayout from "../../../common/cardLayout/CardLayout";
import PatientLoader from "../../../common/PatientLoader";

const DailyPieChart = ({ title, days, loading, data }) => {
  ChartJS.register(ArcElement, Tooltip, Legend);
  // console.log("data: ", data);
  // console.log("days: ", days);
  let YesCount = 0;
  let NoCount = 0;
  let NoResponseCount = days;
  data?.forEach((element, index) => {
    if (element.score === 1) YesCount = YesCount + 1;

    if (element.score === 0) NoCount = NoCount + 1;
  });
  NoResponseCount = NoResponseCount - YesCount - NoCount;

  YesCount = (YesCount / days) * 100; //4/1766
  NoCount = (NoCount / days) * 100; //1/1766
  NoResponseCount = (NoResponseCount / days) * 100; //100
  const chartData = {
    labels: ["Yes", "No", "Not Responded"],
    datasets: [
      {
        label: title,
        data: [YesCount, NoCount, NoResponseCount],
        backgroundColor: ["#395E9D", "#FA8581", "#82D4E7"],
        borderWidth: 1,
      },
    ],
  };

  return (
    <CardLayout
      className="col-sm-12 col-md-6 col-lg-6"
      style={{
        border: "5px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="container-fluid">
        <div className="d-flex justify-content-start mt-3 mb-5">
          <h6 className="info-card-title">
            <strong>{title}</strong>
          </h6>
        </div>
        <div className="container-fluid p-3 mb-3">
          {loading ? (
            <PatientLoader />
          ) : (
            <div
              className="w-100 container-fluid d-flex justify-content-center"
              style={{
                alignItems: "center",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <div className="w-50">
                <Pie data={chartData} />
              </div>
            </div>
          )}
        </div>
      </div>
    </CardLayout>
  );
};

export default DailyPieChart;
